import { rgbaToHex, hexToHSV, hsvToHex } from '_lib/utils/utilsColor.js'
import Worker from "./color.worker.js";

// sMin: HSV S最小值； sMax: HSV S最大值； type: 1-取全图，2-取下半部分图
function getThemeColor(file, {sMin, sMax, vMin, vMax, type}, is_gradient ) {
  return new Promise((resolve, reject) => {
    const worker = new Worker();
    
    worker.addEventListener('message', function(event) {
      const mostCommonColor = event.data;
      if (mostCommonColor) {
        let hex = rgbaToHex(mostCommonColor)
        let hsv = hexToHSV(hex, {sMin, sMax, vMin, vMax})
        if(!is_gradient) resolve(hsvToHex(hsv));
        let hsv_arr = [{
          h: hsv.h,
          s: hsv.s + 10,
          v: hsv.v - 5
        }, {
          h: hsv.h,
          s: hsv.s,
          v: hsv.v + 10
        }]
        resolve(hsv_arr.map(item => hsvToHex(item)));
      } else {
        reject(new Error('处理图像失败'));
      }
    });
    
    worker.addEventListener('error', function(e) {
      reject(new Error('工作器错误'));
    });
    worker.postMessage({file, type});
  });
}
export { getThemeColor }